import { Package } from "lucide-react";
import { Card } from "@/components/ui/card";

const vigente = (o) => !o.anulado && o.estado !== "cancelado";
const unidades = (o) => (o.items || []).reduce((n, it) => n + (Number(it.cantidad) || 0), 0);

export const articulosVendidos = (orders) => {
  const v = orders.filter(vigente);
  return { pedidos: v.length, unidades: v.reduce((n, o) => n + unidades(o), 0) };
};

export const ArticulosPorUsuario = ({ orders, users }) => {
  const m = {};
  orders.filter(vigente).forEach((o) => {
    const k = o.creado_por || "—";
    m[k] = m[k] || { pedidos: 0, unidades: 0 };
    m[k].pedidos += 1;
    m[k].unidades += unidades(o);
  });
  const rows = Object.entries(m).sort((a, b) => b[1].unidades - a[1].unidades);
  if (!rows.length) return null;
  const nombre = (e) => users.find((u) => u.email === e)?.name || e;
  return (
    <Card className="border-zinc-200 rounded-md overflow-hidden" data-testid="articulos-por-usuario">
      <div className="p-4 border-b border-zinc-200 flex items-center gap-2"><Package className="w-4 h-4 text-[#7C3AED]" /><span className="font-semibold">Artículos vendidos por usuario</span></div>
      <table className="w-full text-sm">
        <thead className="bg-zinc-50 text-zinc-600"><tr className="text-left"><th className="px-4 py-2 text-xs uppercase tracking-widest">Usuario</th><th className="px-4 py-2 text-xs uppercase tracking-widest text-right">Pedidos</th><th className="px-4 py-2 text-xs uppercase tracking-widest text-right">Unidades</th></tr></thead>
        <tbody className="divide-y divide-zinc-100">
          {rows.map(([e, r]) => <tr key={e} data-testid={`articulos-user-${e}`}><td className="px-4 py-2">{nombre(e)}</td><td className="px-4 py-2 text-right tabular-nums">{r.pedidos}</td><td className="px-4 py-2 text-right font-bold tabular-nums">{r.unidades}</td></tr>)}
        </tbody>
      </table>
    </Card>
  );
};
